var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui grid"},[_c('div',{staticClass:"four wide column"},[_c('professor-picker',{on:{"select_professor":_vm.select_professor}})],1),_c('div',{staticClass:"twelve wide column"},[_c('detail',{ref:"detail",attrs:{"professors":_vm.grouped}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }